import * as React from "react";
import { cn } from "@/lib/utils";
import type { OrderDecoprofStatus } from "@/lib/ordersDecoprof";

/**
 * 3D-pill badge voor Orders Decoprof statussen.
 * - Nieuw       → blauw (#3B82F6)
 * - Uitgeprint  → groen (#10B981)
 * - Aangemaakt  → paars (#8B5CF6)
 *
 * Effect = soft drop-shadow + lichte top-highlight + inset gradient.
 * Herbruikbaar; niet vervlochten met shadcn variants zodat de kleurmap
 * ge centraliseerd blijft.
 */
const STATUS_COLORS: Record<OrderDecoprofStatus, { bg: string; ring: string }> = {
  Nieuw:       { bg: "bg-blue-500",    ring: "ring-blue-300/50" },
  Uitgeprint:  { bg: "bg-emerald-500", ring: "ring-emerald-300/50" },
  Aangemaakt:  { bg: "bg-violet-500",  ring: "ring-violet-300/50" },
};

interface Props {
  status: OrderDecoprofStatus;
  className?: string;
}

export const BadgeStatus3D: React.FC<Props> = ({ status, className }) => {
  const c = STATUS_COLORS[status] ?? STATUS_COLORS.Nieuw;
  return (
    <span
      className={cn(
        "relative inline-flex items-center justify-center",
        "px-3 py-1 text-xs font-semibold text-white rounded-full",
        "shadow-[0_2px_4px_rgba(0,0,0,0.15),inset_0_1px_0_rgba(255,255,255,0.35),inset_0_-1px_0_rgba(0,0,0,0.15)]",
        "ring-1",
        c.bg,
        c.ring,
        className,
      )}
    >
      {/* Lichte top-highlight voor extra 3D-look */}
      <span
        aria-hidden
        className="absolute inset-x-1 top-0.5 h-1/2 rounded-full bg-white/20 blur-[1px] pointer-events-none"
      />
      <span className="relative">{status}</span>
    </span>
  );
};

export default BadgeStatus3D;
